module.exports = __webpack_public_path__ + "static/Graphik-Semibold-Web-4523b7c1b50782f74e3c18bb2f96f250.woff2";